import React, { Component } from 'react';
import { Utils } from '../../utils/Utils';

class AutoASRandJudge extends Component {

    constructor(props) {
        super(props);
        this.state = {
            arsJudgeStatus: 0,  //1-录音中；2-录音结束
            volumnWave: [], //存放声音波形
            speechResultMiddle_Hit: [],
            markGreen: false,
        };
        // this.timeoutInterval = null;
        const answer = props.item && props.item.detail && props.item.detail.answer ? props.item.detail.answer : "";
        this.showText = props.item && props.item.detail && props.item.detail.showText ? props.item.detail.showText : "";
        this.obtainRecordInterval = null;
        this.maxVolumnTimer = null;
        this.avgVolumnTimer = null;
        this.minVolumn = answer.length / 2 + 5;    //最小声音分贝要求(不是真正的分贝)，字母越多，要求平均分贝越高
        this.volumnState = -1; //0-开始静音状态；1-有声音状态；2-有声音后又静音2s的状态/主动点击完成了
    }

    /**
     * timeout 倒计时总时间
     * countdown 快结束的动画
     */
    componentDidMount() {
        const that = this;
        const { item } = this.props;
        if (item.actionType === "ASRAndJudgeReplayAction_") {
            that.startRecording();
        }
        if (item.actionType === "ASR_REPLAY_HITS") {
            const hit = item.detail && item.detail.hits ? item.detail.hits : [];
            if (hit && hit instanceof Array && hit.length) {
                that.setState({
                    speechResultMiddle_Hit: hit
                });
            }
        }
    }

    componentWillMount() {
        this.removeAsrSay();
    }

    componentWillUnmount() {
        // clearInterval(this.timeoutInterval);
        clearInterval(this.maxVolumnTimer);
    }

    removeAsrSay() {
        const asrSay = document.getElementById('asrSay');
        if (asrSay && asrSay.parentNode) {
            asrSay.parentNode.removeChild(asrSay);
        }
    }

    clearAnimation() {
        let playAnimation = document.getElementById('playAnimation');
        playAnimation.innerHTML = "";    //清空动画容器
        playAnimation.setAttribute('class', 'hide');    //清空动画容器
        playAnimation.style.top = 0;
        playAnimation.style.left = 0;
    }


    /**
     * maxTime 录音时长
     * judgeFunction 录音完的回调
     * parentNode 获取参数的父节点
     * answer 正确答案
     */
    startRecording() {
        const that = this;
        const { item } = this.props;
        setTimeout(() => {  //话筒出来的动画时间

            that.setState({
                arsJudgeStatus: 1
            }, () => {
                // 开始录音之后，隔一会就更新当前的最大值
                let volumn2s = [];  //存放2s的音频数据，用户做静音检测自动结束
                let volumn5s = [];  //存放5s的音频数据，用户做静音检测出tips
                let volumnTips = document.getElementById('volumnTips');
                if (volumnTips) {
                    that.maxVolumnTimer = setInterval(() => {
                        let volumn = Math.floor((window.maxVolumn / 1.5) * 90);
                        // console.log('volumn:', volumn)
                        let volumnArr = [];
                        for (let i = 0; i < 11; i++) {
                            volumnArr.push(volumn > 5 ? Utils.randomFrom(5, Math.min(volumn, 45)) : 5);
                        }
                        that.setState({
                            volumnWave: volumnArr
                        });
                        volumn2s.push(volumn || 0);
                        volumn5s.push(volumn || 0);
                    }, 100);

                    //第5s检测静音，静音出提示
                    setTimeout(() => {
                        let avg = Utils.arrayAvg(volumn5s); //声音平均值
                        if (avg <= that.minVolumn && that.volumnState !== 1) {
                            volumnTips.setAttribute('class', 'hide'); //先不出
                        } else {
                            volumnTips.setAttribute('class', 'hide');
                        }
                    }, 5000);
                }

                //静音检测，每2s检测前2s的平均值，小于 that.minVolumn 出提示
                that.avgVolumnTimer = setInterval(() => {
                    // console.log('arrayAvg:', volumn2s, Utils.arrayAvg(volumn2s));
                    let avg = Utils.arrayAvg(volumn2s); //声音平均值
                    if (avg > that.minVolumn && that.volumnState !== 2) {
                        that.volumnState = 1;
                    } else if (avg <= that.minVolumn && that.volumnState === 1) {
                        that.volumnState = 2;
                    } else if (avg <= that.minVolumn && that.volumnState === -1) {
                        that.volumnState = 0;
                    }
                    volumn2s = [];
                }, 2000);

                let maxTime = item && item.detail && item.detail.answer ? Math.min(7 + item.detail.answer.split(' ').length, 8) : 8; //计算最大停止时间 5+单词数，微信超过8s会超时
                if (maxTime) {
                    let interTime = 0;
                    that.obtainRecordInterval = setInterval(() => {
                        interTime++;
                        // console.log('interTime:', interTime)
                        // console.log('is:', (interTime >= maxTime || that.volumnState === 2) ? 1 : 0)
                        if (interTime >= maxTime || that.volumnState === 2) {
                            //结束条件：超过最大时间 || 说过话后超过2s是静音状态
                            that.stopRecord();
                            clearInterval(that.obtainRecordInterval);
                        }

                        // 倒计时3s，一直静音的情况出
                        const asrCountdown = document.getElementById('asrCountdown');
                        if (asrCountdown && maxTime - interTime < 4 && that.volumnState < 2) {
                            asrCountdown.innerText = maxTime - interTime;
                        }
                    }, 1000);
                }
            });
        }, 1000);
    }
    stopRecord() {
        const that = this;
        that.clearAnimation();
        clearInterval(that.maxVolumnTimer);
        clearInterval(that.avgVolumnTimer);
        that.setState({
            arsJudgeStatus: 2
        }, () => {
            that.removeAsrSay();
        });
    };

    handleFileSelector(e) {
        alert(e);
    }

    render() {
        const that = this;
        const { arsJudgeStatus, volumnWave, speechResultMiddle_Hit, markGreen } = this.state;
        return (
            <div id="asrSay" className={arsJudgeStatus === 2 ? "clear-bg" : "asr-say opacityBg"}>
                {
                    arsJudgeStatus === 1 ?
                        <div className="micro">
                            <ul className="wave">
                                {
                                    volumnWave.map((item, index) => {
                                        return <li key={index} style={{ "height": `${item}px`, "marginTop": `${22 - item / 2}px` }} />
                                    })
                                }
                            </ul>
                            <ul className="wave2">
                                {
                                    volumnWave.map((item, index) => {
                                        return <li key={index} style={{ "height": `${item}px`, "marginTop": `${22 - item / 2}px` }} />
                                    })
                                }
                            </ul>
                            <div id="volumnTips" className="hide">没有听到您的声音，请大声，或检查麦克风设置。</div>
                            <div id="asrCountdown" />
                            <div id="asrComplete">说完了</div>
                        </div>
                        : null
                }

                {
                    that.showText && (arsJudgeStatus === 1 || arsJudgeStatus === 2) ?
                        <div id="showText">
                            {
                                speechResultMiddle_Hit && speechResultMiddle_Hit.length ?
                                    <div className="table-cell">
                                        {
                                            speechResultMiddle_Hit.map((speechResult, index) => {
                                                return (
                                                    <div key={index} className={speechResult.hit ? (arsJudgeStatus === 1 ? "word word-big" : (markGreen ? "word word-green" : "word")) : (markGreen ? "word word-red" : "word")}><div id={"wordAni" + index} className="word-ani" />{speechResult.word}</div>
                                                )
                                            })
                                        }
                                    </div>
                                    :
                                    <div className="table-cell">
                                        {
                                            that.showText ?
                                                that.showText.split(' ').map((text, index) => {
                                                    return (
                                                        <div className="word" key={index}>{text}</div>
                                                    )
                                                })
                                                : null
                                        }
                                    </div>
                            }
                        </div>
                        : null
                }
            </div>
        );
    }
}

export default AutoASRandJudge;



// WEBPACK FOOTER //
// ./src/components/review/AutoASRandJudge.js